import React, { Component, Fragment } from 'react';
import { Box, Button, Card, Heading, Paragraph, Set } from 'bumbag';
import _get from 'lodash/get';
import Lever from 'react-lever';
import Loads from 'react-loads';

import DataList from '@medipass/react-core/DataList';
import { Link as RouterLink } from '@medipass/react-core/router';
import WithErrorMessage from '@medipass/react-core/WithErrorMessage';
import WithLoadingIndicator from '@medipass/react-core/WithLoadingIndicator';
import sdk from '@medipass/web-sdk';

import AddHealthFundAccount from 'legacy/components/account/health-fund-accounts/AddHealthFundAccount';
import AddMedicareDetails from 'legacy/components/account/health-fund-accounts/AddMedicareDetails';
import Page from 'legacy/components/account/layout/Page';
import TransactionsList from 'legacy/components/account/transactions/TransactionsList';
import CompletedTransactionMessage from 'legacy/components/CompletedTransactionMessage';
import FirstTimeLoginGreeting from 'legacy/components/FirstTimeLoginGreeting';
import WithAuthentication from 'legacy/components/WithAuthentication';
import WithEmpty from 'legacy/components/WithEmpty';
import mastercard from 'legacy/images/mastercard.svg';
import visa from 'legacy/images/visa.svg';

import { TRANSACTION_ACTIONS } from '../../../constants';
type Props = {};
type State = {
  transactions: Record<string, any>;
};
export default class Transactions extends Component<Props, State> {
  getTransactions = async ({ page }: any = {}) => {
    const accountId = _get(sdk, 'account._id');
    const query = { limit: 10, sort: -1, page: page || 1 };
    const transactions = await sdk.accounts.getAccountTransactions(accountId, query);
    return { items: transactions.items, pageCount: transactions.meta.pageCount };
  };

  render() {
    return (
      <WithAuthentication>
        <Page minWidthBreakpoint="mobile" title="Transactions">
          <Set display="block" orientation="vertical" spacing="major-2">
            {/* @ts-ignore */}
            <CompletedTransactionMessage use={Card} defaultIsActive={false} type={TRANSACTION_ACTIONS.APPROVED} />
            <FirstTimeLoginGreeting />
            <Card>
              <p className="font-semibold">Transactions</p>
              {this.renderTransactions()}
            </Card>
            {this.renderPaymentMethodPanel()}
            {this.renderHealthFundPanels()}
          </Set>
        </Page>
      </WithAuthentication>
    );
  }

  renderTransactions = () => {
    return (
      <Box data-testid="transactions-list">
        <DataList
          contextKey="transactions"
          loadData={this.getTransactions}
          loadMoreRenderer={({ loadMore, isLoading }) => (
            <Box textAlign="center">
              <Button palette="primary" variant="ghost" isLoading={isLoading} onClick={loadMore}>
                Load more
              </Button>
            </Box>
          )}
          dataRenderer={({ items }) => (
            <WithEmpty
              iconName="far fa-receipt"
              isActive={items.length === 0}
              emptyText={
                <Box>
                  <Paragraph fontWeight="semibold" color="primary">
                    You do not have any transactions yet.
                  </Paragraph>
                  <Paragraph textAlign="left">
                    Save time and pay with Tyro Health during your next health consultation. A receipt for the
                    transactions including any health fund benefit will be available here.
                  </Paragraph>
                </Box>
              }
            >
              <TransactionsList items={items} />
            </WithEmpty>
          )}
          errorRenderer={({ error }) => (
            <Box textAlign="center">
              <WithErrorMessage isActive description="Unable to load your transactions" error={error} />
            </Box>
          )}
          loadingRenderer={() => (
            <Box textAlign="center">
              <WithLoadingIndicator isActive />
            </Box>
          )}
        />
      </Box>
    );
  };

  renderPaymentMethodPanel = () => {
    return (
      <Loads
        contextKey="paymentMethods"
        loadOnMount
        load={() => sdk.payments.getAccountPaymentMethods(_get(sdk, 'account._id'))}
      >
        {/* @ts-expect-error TS(7031): Binding element 'paymentMethods' implicitly has an... Remove this comment to see the full error message */}
        {({ response: paymentMethods, isSuccess }) =>
          isSuccess && paymentMethods && paymentMethods.length === 0 ? (
            <Card>
              <Heading use="h6" fontWeight="semibold">
                Add your payment card
              </Heading>
              <Paragraph>Add a payment card to enable payment of any out of pocket services.</Paragraph>
              <Box display="flex" justifyContent="center">
                <img src={mastercard} alt="MasterCard" />
                <img className="margin-left-10" src={visa} alt="Visa" />
              </Box>
              <Button
                //@ts-expect-error
                use={RouterLink}
                to="/account/payment-methods/create/"
                palette="secondary"
                marginTop="major-2"
                width="100%"
              >
                ADD PAYMENT CARD
              </Button>
            </Card>
          ) : null
        }
      </Loads>
    );
  };

  renderHealthFundPanels = () => {
    return (
      <Loads
        contextKey={`member-${_get(sdk, 'member._id')}`}
        loadOnMount
        load={() => sdk.members.getMember(_get(sdk, 'member._id'))}
      >
        {/* @ts-expect-error TS(7031): Binding element 'member' implicitly has an 'any' t... Remove this comment to see the full error message */}
        {({ response: member, isSuccess }) =>
          isSuccess ? (
            <Fragment>
              {!member.defaultHealthFundAccountId && (
                <Card>
                  <AddHealthFundAccount isSmallImage />
                </Card>
              )}
              <Lever feature="medicare">
                {!member.medicareHealthFundAccountId && (
                  <Card>
                    <AddMedicareDetails isSmallImage />
                  </Card>
                )}
              </Lever>
            </Fragment>
          ) : null
        }
      </Loads>
    );
  };
}
